/**
 * TypeScript wrapper for the WASM vertex SpatialGrid used by the sculpt
 * engine. (The previous per-triangle variant was consumed only by the
 * texture-atlas sketch system; both have been removed along with that
 * system.)
 */

import {
  type SpatialGrid as WasmSpatialGrid,
  spatial_grid_from_vertices as wasmFromVertices,
} from "./pkg/poseref_wasm.js";

// ---------------------------------------------------------------------------
// Sculpt grid — vertex indices, incremental updates.
// ---------------------------------------------------------------------------

/**
 * Vertex-index spatial grid. Same public surface as the original class in
 * `sculpt/spatialIndex.ts`, so callers don't change.
 */
export class SpatialGrid {
  private handle: WasmSpatialGrid;

  constructor(vertices: Float32Array, cellSize: number) {
    this.handle = wasmFromVertices(vertices, cellSize);
  }

  get cellSize(): number {
    return this.handle.cell_size;
  }

  setCellSize(cellSize: number): void {
    this.handle.set_cell_size(cellSize);
  }

  updateVertices(
    indices: number[] | Uint32Array,
    vertices: Float32Array,
  ): void {
    const idx =
      indices instanceof Uint32Array ? indices : Uint32Array.from(indices);
    this.handle.update_points(idx, vertices);
  }

  queryRadius(cx: number, cy: number, cz: number, radius: number): number[] {
    const result = this.handle.query_radius(cx, cy, cz, radius);
    const out = new Array<number>(result.length);
    for (let i = 0; i < result.length; i++) out[i] = result[i];
    return out;
  }
}
